<h3 matDialogTitle class="title"><span>{{title}}</span></h3>
<!-- Alternatively, use <mat-dialog-content> for the dialog's content -->
<div mat-dialog-content>
    <p>{{message}}</p>
    <!-- <mat-button-toggle value="bold">Bold</mat-button-toggle> -->
</div>
<!-- Alternatively, use <mat-dialog-actions> for the dialog's actions -->
<div mat-dialog-actions>
    <button mat-button matDialogClose="Cancel" color="primary" class="example-uppercase-btn danger " *ngIf="hasCancel">{{ 'Public.Cancel' | translate }}</button>
    <button mat-button matDialogClose="Ok" color="primary" class="example-uppercase-btn success" *ngIf="hasOK">{{ 'Public.Ok' | translate }}</button>
</div>
